var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileReady)?_c('div',[_vm._v(" sdf ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }